import React from 'react';

import DeleteBtn from '../Base/DeleteBtn';
import SpaceConfigs from '../Base/SpaceConfigs';
import DuplicateBtn from '../Base/DuplicateBtn';

import { ISpace } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';
import BackgroundConfigs from '../Base/BackgroundConfigs';

interface IProps {
  space: ISpace<ElementTypes>;
}

class EditFormFieldSelect extends React.PureComponent<IProps> {
  public render() {
    const { space } = this.props;

    return (
      <>
        <SpaceConfigs space={space} />
        <BackgroundConfigs space={space} />
        <DuplicateBtn spaceId={space.id} />
        <DeleteBtn spaceId={space.id} />
      </>
    );
  }
}

export default EditFormFieldSelect;
